<!--选择 学年-学期-->
<template>
  <el-cascader
    v-model="ids"
    :clearable="true"
    size="small"
    :options="treeData"
    collapse-tags
    class="select-student w-100"
    placeholder="请选择"
    :props="{multiple: multiple, value: 'code', label: 'intro'}"
    @change="onChange"
  />
</template>
<script>
import fetch from '@/utils/fetch'

export default {
  model: {
    event: 'change'
  },
  props: {
    api: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    initSelected: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      ids: [],
      treeData: []
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.ids = newVal
      },
      immediate: true
    }
  },
  created() {
    this.getTree()
  },
  methods: {
    getTree() {
      return fetch({
        url: this.api,
        method: 'post',
        data: {}
      }).then(res => {
        this.treeData = res.data.array
        this.initSelected && this.reset()
        this.$emit('loaded', res.data.array)
      }).catch(() => {
        // this.loading = false
      })
    },
    reset() {
      let stageList = []
      const _setLatest = (list) => {
        let target = list.find((item) => item.hadCheck === 1)
        stageList.push(target.code)
        if (target.children) {
          _setLatest(target.children)
        }
      }
      _setLatest(this.treeData)
      // console.log(stageList)
      this.$emit('change', stageList)
    },
    onChange(val) {
      this.$emit('change', val)
    }
  }
}
</script>
<style lang="scss" scoped type="text/scss">
  .nothingBox{
    text-align: center;
    padding: 100px 0;
    img{
      margin: 50px auto 0 auto;
      width: 240px;
    }
    p{
      text-align: center;
      font-size: 14px;
      color: #999;
      line-height: 30px;
    }
  }
</style>
